import api from 'dashboard/resources/site-financial-status.api';
import actionTypes from './action-types';

export const fetchSiteFinancialStatusRequest = () => ({
  type: actionTypes.FETCH_SITE_FINANCIAL_STATUS_REQUEST,
  name: 'siteFinancialStatusLoadingStatus',
});

export const fetchSiteFinancialStatusSuccess = (data) => ({
  type: actionTypes.FETCH_SITE_FINANCIAL_STATUS_SUCCESS,
  name: 'siteFinancialStatusLoadingStatus',
  data,
});

export const fetchSiteFinancialStatusFailure = () => ({
  type: actionTypes.FETCH_SITE_FINANCIAL_STATUS_FAILURE,
  name: 'siteFinancialStatusLoadingStatus',
});

export const fetchSiteFinancialStatus = (retailerId) => async (dispatch) => {
  try {
    dispatch(fetchSiteFinancialStatusRequest());
    const data = await api.fetchSiteFinancialStatus(retailerId);
    dispatch(fetchSiteFinancialStatusSuccess(data));
  } catch (error) {
    console.error('FETCH_SITE_FINANCIAL_STATUS', error);
    dispatch(fetchSiteFinancialStatusFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/site-financial-status/site-financial-status.actions.js